import { Component, Output, EventEmitter } from '@angular/core';
import { Audience } from '../../interfaces/audience.model';
import { StorageProvider } from '../../providers/storage/storage';
import { AudienceProvider } from '../../providers/audience/audience';
import { FilterProvider } from '../../providers/filter/filter';

@Component({
  selector: 'audience-filter',
  templateUrl: 'audience-filter.html'
})
export class AudienceFilterComponent {

  audiences: Audience[];
  selectedAudience: Audience;
  @Output() changed: EventEmitter<any> = new EventEmitter();

  constructor(public storageService: StorageProvider, public filterService: FilterProvider, public audienceService: AudienceProvider) {
    this.audiences = this.audienceService.getAllAudiences();

    this.audienceService.currentAudience.subscribe(selectedAudience => {
      this.setSelectedAudience(selectedAudience);
    });
  }

  setSelectedAudience(selectedAudience){
    if(selectedAudience == null){
      this.selectedAudience = this.audiences[0];
      this.audienceService.setSelectedAudience(this.selectedAudience);
    } else {
      this.selectedAudience = this.audiences.find(aud => aud.AudienceId == selectedAudience.AudienceId);
    }
  }

  audienceChanged(audience){
    this.audienceService.setSelectedAudience(audience).then(() => {
      this.filterService.filterAssets().then(() => this.changed.emit(null));
    });
  }

}



// WEBPACK FOOTER //
// ./src/components/audience-filter/audience-filter.ts